import React, {useState} from "react";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import {Alert, Button, Chip, styled, TableCell, TableContainer, TextField, Tooltip, Typography} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import {convertDateToTimeString} from "../utils/cert-helper";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import RunCircleRoundedIcon from '@mui/icons-material/RunCircleRounded';
import ReportRoundedIcon from '@mui/icons-material/ReportRounded';
import {statusObj} from "../utils/customFunctions";

const StyledTableRow = styled(TableRow)(({theme}) => ({
    // hide last border
    '& td': {padding: 0, lineHeight: '14px', fontSize: '15px'},
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
const StyledTableCell = styled(TableCell)({
    fontWeight: 'bold'
})

const StyledSpan = styled('span')({
    padding: '2px'
})
const StyledTypography = styled(Typography) ({
    fontSize: '0.875rem',
})
const StyledDetailDiv = styled('div')({
    '& .value': {
        color: '#1769aa',
    }
})
const acceptedObj = {
    accepted: {
        value: 'ACCEPTED', color: 'success'
    },
    rejected: {
        value: 'REJECTED', color: 'warning'
    }
}

export default function ContributionsAsWidgetList(props) {
    const contributions = props.contributions || [];

    const handleStatusColor = (status) => {
        const statusIcon = () => {
            switch (status) {
                case 'Completed':
                    return <CheckCircleIcon/>
                case 'Init':
                case 'Running':
                    return <RunCircleRoundedIcon/>
                case 'Cancel':
                case 'Failed':
                    return <CancelRoundedIcon/>
                default:
                    return <ReportRoundedIcon/>
            }
        }

        const color = statusObj[status];
        if (color !== undefined) {
            return (
                <Chip icon={statusIcon(status)}
                      variant='outlined'
                      label={status.toUpperCase()}
                      color={color}
                      sx={{width: '100%', m: '8px 0', '& span': {paddingTop: '3px'}}}
                />
            )
        }
    }

    const handleAcceptedColor = (accepted) => {
        const obj = accepted ? acceptedObj.accepted : acceptedObj.rejected;

        return <Alert color={obj.color} icon={false}
                      sx={{display: 'flex', justifyContent: 'center', padding: 0}}>{obj.value}</Alert>

    }

    return (
            <Table sx={{m: 0}}>
                {/*<TableHead>*/}
                {/*    <TableRow >*/}
                {/*        <StyledTableCell>Hisp / Status</StyledTableCell>*/}
                {/*        <StyledTableCell>Details</StyledTableCell>*/}
                {/*        <StyledTableCell style={{ width: '350px'}}>Validation Information</StyledTableCell>*/}
                {/*        <StyledTableCell>Submission/Publish Time</StyledTableCell>*/}
                {/*        /!*<StyledTableCell>Last Published Time</StyledTableCell>*!/*/}
                {/*        {!minimum && <StyledTableCell>Report</StyledTableCell> }*/}

                {/*    </TableRow>*/}
                {/*</TableHead>*/}
                <TableBody>
                    {contributions && contributions.map(c => (
                        <StyledTableRow key={c.id}>
                            <TableCell >
                                <span style={{color: '#1769aa', marginRight: 20}}>{convertDateToTimeString(c.submissionTs)}</span>
                            </TableCell>
                            <TableCell>
                                <span style={{marginRight: 12}}><strong style={{color: "#555555"}}>{c.hisp}</strong> submitted {c.inputRecordCount} records.</span>
                                (
                                <span style={{marginRight: 5}}>{c.errorCount} errors </span>
                                <span style={{marginRight: 5}}>{c.warningCount} warnings </span>
                                <span style={{marginRight: 5}}>{c.alertCount} alerts </span>
                                )
                                {/*<span style={{marginRight: 5}}>{c.errorCount} errors ({c.toleratedErrorCount} Tolerated / {c.errorCount - c.toleratedErrorCount} UnTolerated) </span>*/}
                                {/*<span style={{marginRight: 5}}>{c.warningCount} warning ({c.toleratedWarningCount} Tolerated / {c.warningCount - c.toleratedWarningCount} UnTolerated) </span>*/}
                                {/*<span style={{marginRight: 5}}>{c.alertCount} alert ({c.toleratedAlertCount} Tolerated / {c.alertCount - c.toleratedAlertCount} UnTolerated) </span>*/}
                            </TableCell>
                            <TableCell>
                                {c.status === 'Completed'
                                    ? <StyledSpan>{handleAcceptedColor(c.accepted)}</StyledSpan>
                                    : <StyledSpan>{handleStatusColor(c.status)}</StyledSpan>
                                }
                            </TableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
    )
}
